import React from "react";
import './About.css'

export default function About() {
  return <div className="about">
    <h1>About us</h1>
    <p>This Web app is about the four scales of Ethiopian music.Which are Ambasel ,Bati ,Tizita and Anchihoye
      .You can click on your interesrt and you can get short description about the scale and music and artisc with that scale selected Category.The instrumennt you can get ot know the some cultrural 
      instrument and in the future we will link you to the path where you can buy this instrumnet. Also in the future we will let user rate the music they listen with the log in account. </p>
  </div>;
}
